import React, {useEffect} from "react";
import {FiMail, FiMapPin, FiPhone} from "react-icons/fi";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {FaUserCircle} from "react-icons/fa";
import LoadingSpinner from "../../components/LoadingSpinner";
import PageName from "../../components/PageName";
import {MissingMonths} from "../../redux/selfService/selfServiceSlice";
import Card from "../../components/Base/Card";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const MissingMonthsPage = ()=>{
    const dispatch = useAppDispatch();
    const { missingMonths, isLoading } = useAppSelector((state) => state?.selfService);
    const { user } = useAppSelector((state) => state?.auth);


    useEffect(()=>{
        if(user && user.pin) {
            dispatch(MissingMonths(user.pin));
        }
    }, [user])


    return (
      <TimeOutActivityLayout>
        <div className="support-page">
            <PageName pageName={"Contribution Missing Months"}/>
          {/* <div className="w-full max-w-[500px] mx-auto py-16"> */}
          <div className="w-full min-w-[900px] max-w-[500px] mx-auto p-10">
            <div className="acm__head">
              Missing Months
            </div>

            {/*<div className="account-manager acm">*/}
              <Card className="py-10">
                {isLoading ?
                  <div className="flex justify-center">
                    <LoadingSpinner size={"md"} />
                  </div>
                    :
                    <div className="acm__body">
                      <div className="acm__body--item">
                        <div className="acm__body--item-head">
                          Name:
                        </div>
                        <div className="acm__body--item-text">
                          {missingMonths?.txtname}
                        </div>
                      </div>
                      <div className="acm__body--item">
                        <div className="acm__body--item-head">
                          Last Contribution:
                        </div>
                        <div className="acm__body--item-text">
                          {missingMonths?.lastcontribution}
                        </div>
                      </div>
                      <div className="acm__body--item">
                        <div className="acm__body--item-head">
                          Last Paying Employer:
                        </div>
                        <div className="acm__body--item-text">
                          {missingMonths?.lastPayingEmployer}
                        </div>
                      </div>
                      <div className="acm__body--item">
                        <div className="acm__body--item-head">
                          Last Contribution Date:
                        </div>
                        <div className="acm__body--item-text">
                          {missingMonths?.lastContributionDate}
                        </div>
                      </div>


                        <div className="acm__missingMonths mt-12">
                            {
                                missingMonths?.missingmonths?.map((m, index)=>(
                                    <Card className="p-4 mb-2" key={index}>{m}</Card>
                                ))
                            }
                        </div>
                    </div>
                }
              </Card>
            {/*</div>*/}
          </div>
        </div>
        </TimeOutActivityLayout>
    )
}

export default MissingMonthsPage;